<template>
  <div class="Equipment">
    <van-sticky @scroll="stickyChange" :class="stickyChangeFlag ? 'stickyBottom' : ''">
      <van-search v-model="paramsList.iccid" show-action placeholder="请输入要查询的ICCID" @search="onSearch" @cancel="onCancel" />
    </van-sticky>
    <VANABS :total=total :listFlag=listFlag :list=list @changList = changList :searchValue=searchValue></VANABS>
  </div>
</template>

<script>
import VANABS from '@/components/EquipmentBeyondTab'
import { EquipmentBeyond } from '@/api/Equipment.js'
export default {
  components: { VANABS },
  props: {},
  data () {
    return {
      searchValue: '',
      stickyChangeFlag: false,
      list: [],
      total: 0,
      paramsList: {
        token: this.$store.state.token,
        userId: this.$store.state.userID.split('a')[0],
        page: 1,
        limit: 10,
        iccid: ''
      },
      // list是否有数
      listFlag: 'one',
      closeFlag: false
    }
  },
  watch: {},
  computed: {},
  methods: {
    async onSearch () {
      if (this.paramsList.iccid) {
        this.closeFlag = true
      } else {
        this.closeFlag = false
      }
      this.searchValue = this.paramsList.iccid
      this.listFlag = 'three'
      const { data: res } = await EquipmentBeyond(this.paramsList)
      this.list = res.extend.rows
      this.total = res.extend.records
      this.$nextTick(_ => {
        if (this.list.length === 0) {
          this.listFlag = 'two'
        } else {
          this.listFlag = 'one'
        }
      })
    },
    async onCancel () {
      if (!this.closeFlag) return
      this.listFlag = 'three'
      this.searchValue = ''
      this.paramsList.iccid = ''
      const { data: res } = await EquipmentBeyond(this.paramsList)
      this.list = res.extend.rows
      this.total = res.extend.records
      this.$nextTick(_ => {
        this.listFlag = 'one'
      })
    },
    stickyChange (e) {
      this.stickyChangeFlag = e.isFixed
    },
    changList (e) {
      if (e.type === 'add') {
        this.list.push(...e.list)
        this.total = e.total
      } else {
        this.list = []
        this.total = 0
      }
    }
  },
  beforeCreate () {},
  created () {
  },
  mounted () {}
}
</script>

<style scoped lang='less'>
  .Equipment {
    height: 100%;
    padding-bottom: 100px;
    box-sizing: border-box;
    .van-search {
      width: 750px;
      .van-search__content {
        border-radius: 15px;
      }
    }
  }
  /deep/.van-tabs__content {
    margin-top: 12px;
  }
  .stickyBottom {
    /deep/.van-sticky {
      border-bottom: 1px solid #f3f3f3;
    }
  }
</style>
